module.exports = __webpack_public_path__ + "img/Anna.6f6d1d07.jpg";